import { createFileRoute } from '@tanstack/react-router'
import DiscrepanciesPage from '@/pages/DiscrepanciesPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/discrepancies')({
  component: DiscrepanciesPage,
})